import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Layout } from "@/components/Layout";
import { ArrowLeft, Bell, BellOff } from "lucide-react";

export default function NotificationsInbox() {
    const [items, setItems] = useState([]);
    const [unread, setUnread] = useState(0);
    const [loading, setLoading] = useState(true);

    const refresh = async () => {
        const r = await api.get("/notifications/inbox");
        setItems(r.data.items); setUnread(r.data.unread || 0);
    };
    useEffect(() => { refresh().finally(() => setLoading(false)); }, []);

    const markRead = async (nid) => {
        await api.post(`/notifications/${nid}/read`);
        refresh();
    };

    return (
        <Layout>
            <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-slate-600 hover:text-oxford mb-4">
                <ArrowLeft className="w-4 h-4" /> Mbrapa
            </Link>
            <div className="mb-6">
                <div className="text-xs uppercase tracking-[0.18em] text-slate-500 mb-2">Njoftime</div>
                <h1 className="font-heading text-3xl sm:text-4xl font-black text-slate-900 tracking-tight">Inbox</h1>
                <p className="text-slate-600 mt-2 text-sm">{unread > 0 ? `${unread} të palexuara` : "Asnjë e palexuar"}</p>
            </div>
            {loading ? <div>Duke ngarkuar…</div> : items.length === 0 ? (
                <div className="bg-white border border-slate-200 rounded-2xl p-10 text-center"><BellOff className="w-10 h-10 text-slate-400 mx-auto mb-4" /><div className="font-heading text-xl font-bold">Pa njoftime</div></div>
            ) : (
                <div className="space-y-2">
                    {items.map((n) => (
                        <div key={n.id} onClick={() => !n.read && markRead(n.id)}
                            className={`bg-white border rounded-2xl p-4 sm:p-5 flex gap-3 cursor-pointer ${n.read ? "border-slate-200" : "border-oxford/40 bg-oxford/5"}`}
                            data-testid={`notif-${n.id}`}>
                            <div className={`w-10 h-10 rounded-xl flex items-center justify-center shrink-0 ${n.read ? "bg-slate-100 text-slate-500" : "bg-oxford text-white"}`}>
                                <Bell className="w-5 h-5" />
                            </div>
                            <div className="flex-1 min-w-0">
                                <div className="flex items-center gap-2 mb-1">
                                    <span className="font-bold text-slate-900">{n.title}</span>
                                    {!n.read && <span className="inline-block w-2 h-2 rounded-full bg-oxford" />}
                                </div>
                                <div className="text-xs text-slate-500 mb-1">{n.from_name} • {n.created_at?.slice(0, 16).replace("T", " ")}</div>
                                <p className="text-sm text-slate-700 whitespace-pre-wrap">{n.body}</p>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </Layout>
    );
}
